import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
	selector: '[tooltip]'
})
export class MyToolTipDirective {
	@Input() delay = 0;
	@Input() hideDelay = 300;
	@Input() now: string;
	@Input() placement = 'top';
	@Input() showDelay = 0;
	@Input() tooltip = '';
	@Input() zIndex = false;

	elemPosition: any;
	hideTimeoutId: number;
	showTimeoutId: number;
	tooltipEle: any;
	tooltipOffset = 8;

	constructor(private elementRef: ElementRef) {}
	@HostListener('mouseover')
	@HostListener('focusout')
	@HostListener('mouseleave')
	@HostListener('mousedown')
	onMouseEnter(): void {
		this.showToolTip();
	}

	onMouseLeave(): void {
		this.hide();
	}

	showToolTip(): void {
		this.getElemPosition();

		if (!this.tooltipEle) {
			this.create();
			this.setPosition();
			this.show();
		}
	}

	getElemPosition(): void {
		this.elemPosition = this.elementRef.nativeElement.getBoundingClientRect();
	}

	create(): void {
		this.showDelay = this.delay || this.showDelay;
		this.tooltipEle = document.createElement('span');
		this.tooltipEle.className += 'ng-tooltip ng-tooltip-' + this.placement;
		this.tooltipEle.textContent = this.tooltip;
		if (this.zIndex) {
			this.tooltipEle.style.zIndex = this.zIndex;
		}
		document.body.appendChild(this.tooltipEle);
	}

	show(): void {
		if (this.showTimeoutId) {
			clearTimeout(this.showTimeoutId);
		}

		this.showDelay = this.delay || this.showDelay;
		this.showTimeoutId = window.setTimeout(() => {
			if (this.tooltipEle) {
				this.tooltipEle.className += ' ng-tooltip-show';
			}
		}, this.showDelay);
	}

	hide(): void {
		clearTimeout(this.showTimeoutId);

		if (this.hideTimeoutId) {
			clearTimeout(this.hideTimeoutId);
		}

		if (this.tooltipEle) {
			this.tooltipEle.classList.remove('ng-tooltip-show');
			this.hideTimeoutId = window.setTimeout(() => {
				this.tooltipEle.parentNode.removeChild(this.tooltipEle);
				this.tooltipEle = null;
			}, this.hideDelay);
		}
	}

	setPosition(): void {
		const elemHeight = this.elementRef.nativeElement.offsetHeight;
		const elemWidth = this.elementRef.nativeElement.offsetWidth;
		const tooltipHeight = this.tooltipEle.clientHeight;
		const tooltipWidth = this.tooltipEle.offsetWidth;
		const scrollY = window.pageYOffset;

		if (this.placement === 'top') {
			this.tooltipEle.style.top = this.elemPosition.top + scrollY - (tooltipHeight + this.tooltipOffset) + 'px';
		}

		if (this.placement === 'bottom') {
			this.tooltipEle.style.top = `${this.elemPosition.top + scrollY + elemHeight + this.tooltipOffset}px`;
		}

		if (this.placement === 'top' || this.placement === 'bottom') {
			this.tooltipEle.style.left = this.elemPosition.left + elemWidth / 2 - tooltipWidth / 2 + 'px';
		}

		if (this.placement === 'left') {
			this.tooltipEle.style.left = this.elemPosition.left - tooltipWidth - this.tooltipOffset + 'px';
		}

		if (this.placement === 'right') {
			this.tooltipEle.style.left = `${this.elemPosition.left + elemWidth + this.tooltipOffset}px`;
		}

		if (this.placement === 'left' || this.placement === 'right') {
			this.tooltipEle.style.top =
				this.elemPosition.top + scrollY + elemHeight / 2 - this.tooltipEle.clientHeight / 2 + 'px';
		}
	}
}
